import { headersType } from "../../models";

export const headers: headersType[] = [
  {
    title: "Request #",
    extraClasses: "w-full lg:w-160 pl-0",
    sortKey: "requestNumber",
    isClickable: true,
  },
  {
    title: "Service",
    extraClasses: "w-240 hidden pl-2 lg:block truncate",
    sortKey: "service.name",
    isClickable: true,
  },
  {
    title: "Provider",
    extraClasses: "w-160 hidden lg:block  ",
    sortKey: "",
    isClickable: false,
  },
  {
    title: "Status",
    extraClasses: "w-160 hidden lg:block  ",
    sortKey: "requestState.name",
    isClickable: true,
  },
  {
    title: "Created",
    extraClasses: "w-160 hidden lg:block  ",
    sortKey: "createdDate",
    isClickable: true,
  },
  {
    title: "Comments",
    extraClasses: "w-160 hidden lg:block  ",
    sortKey: "",
    isClickable: false,
  },
];
